import React from 'react';
import './LoadingSpinner.scss';

const LoadingSpinner = ({ size = 40, color = '#3498db' }) => {
  return (
    <div className="LoadingSpinner__container">
      <div
        className="LoadingSpinner"
        style={{
          width: size,
          height: size,
          borderTopColor: color,
        }}
      />
    </div>
  );
};

export default LoadingSpinner;
